import { ReactComponent as EmptyBox } from 'assets/svg/EmptyBox.svg'
import { Typography } from '../../../components/Typography'
export const EmptyState = () => {
  return (
    <div className="flex column full-width align-center mt-32">
      <EmptyBox />
      <Typography.Headline6 className="mt-24 grey-text">
        No additional values
      </Typography.Headline6>
    </div>
  )
}
